import wait from './wait';
export default async function resolveAfter(promise, duration) {
    if (!promise) {
        return true;
    }
    if (!duration) {
        return promise.then(() => true);
    }
    const waitPromise = wait(duration);
    return Promise.race([
        promise.then(() => {
            waitPromise.resolve?.();
            return true;
        }),
        waitPromise.then(() => false),
    ]);
}
